import { 
  colors, 
  layout, 
  forms,
  progress, 
  text, 
  effects,
  utils 
} from '../common.js';

export const styles = {
  // レイアウト
  container: layout.container,
  body: layout.fullScreenCenter,
  
  // プログレスバー
  progressBar: progress.bar,
  progressFill: progress.fill,
  
  // ステップインジケーター
  stepIndicator: {
    textAlign: 'center',
    margin: '0 0 30px 0',
    fontSize: '18px',
    fontWeight: 'bold',
    color: colors.white,
    padding: '15px 25px',
    background: colors.primary,
    borderRadius: '4px'
  },
  
  // テーブル
  table: forms.table,
  th: forms.th,
  td: forms.td,
  
  // 入力フィールド
  input: forms.input,
  verificationCodeInput: {
    textAlign: 'center',
    letterSpacing: '0.5em',
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333'
  },
  
  // 再送信リンク
  resendLink: {
    color: colors.primary,
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '14px',
    background: 'transparent',
    border: 'none',
    padding: '8px 16px',
    margin: '10px 0',
    width: '100%',
    textAlign: 'center'
  },
  
  // 特定コンポーネント用スタイル
  emailDisplay: {
    background: '#f8f9fa',
    padding: '20px',
    borderRadius: '4px',
    marginBottom: '20px',
    textAlign: 'center',
    border: '1px solid #dee2e6'
  },
  
  // テキスト
  helpText: text.helpText,
  timer: text.timer,
  required: text.required,
  
  // ローディング
  loading: effects.loading,
  
  // 成功画面
  successAnimation: {
    textAlign: 'center',
    padding: '40px 0'
  },
  successIcon: {
    fontSize: '80px',
    color: colors.success,
    marginBottom: '20px'
  },
  successTitle: {
    color: colors.success,
    marginBottom: '20px',
    fontSize: '32px',
    border: 'none',
    padding: 0
  }
};

// コンポーネント固有のユーティリティ関数
export const authCodeFormUtils = {
  // プログレスバーの幅を計算
  getProgressWidth: (step) => {
    switch (step) {
      case 1: return '33.33%';
      case 2: return '66.66%';
      case 3: return '100%';
      default: return '33.33%';
    }
  },
  
  // メッセージスタイルを取得（共通ユーティリティを使用）
  getMessageStyle: (messageObj) => {
    if (!messageObj.text) return { display: 'none' };
    return utils.getMessageStyle(messageObj.type);
  },
  
  // ボタンスタイルを取得
  getButtonStyle: (isLoading, buttonType = 'primary') => {
    const modifiers = isLoading ? ['disabled'] : [];
    return utils.combineButtonStyles(buttonType, modifiers);
  }
};